import type { IShape } from '../shapes/interfaces/IShape';

export class SetShapeVisibility {
    private readonly shape: IShape;
    private readonly newVisible: boolean;
    private oldVisible: boolean;

    constructor(shape: IShape, newVisible: boolean) {
        this.shape = shape;
        this.newVisible = newVisible;
        this.oldVisible = shape.visible;
    }

    execute(): void {
        this.shape.visible = this.newVisible;
    }

    undo(): void {
        this.shape.visible = this.oldVisible;
    }
}
